import { render } from "./MRebot.vue?vue&type=template&id=49438b2c&scoped=true"
import script from "./MRebot.vue?vue&type=script&lang=js"
export * from "./MRebot.vue?vue&type=script&lang=js"

import "./MRebot.vue?vue&type=style&index=0&id=49438b2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49438b2c"]])

export default __exports__